import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { OrganisationService } from 'apps/web/src/app/services/organisation.service';
import { Observable } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { Organization } from 'apps/web/src/app/models/organization.interface';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { map } from 'rxjs/operators';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
    calendarItems$: Observable<any>;
    permissions$: Observable<[]>;
    organization$: Observable<Organization>;
    filters: Observable<[]>;

    constructor(
        private service: OrganisationService,
        private permissionsService: NgxPermissionsService,
        private store: Store<fromStore.OrganisationsFeatureState>
    ) {}

    ngOnInit() {
        this.store.dispatch(new fromStore.LoadOrganization());
        this.organization$ = this.store.select(fromStore.getOrganization);
        this.selectFilter(0);
        this.organization$.subscribe(organization => {
            if (organization) {
                const roles = organization.roles.reduce((acc, rl: any) => {
                    return [...acc, rl.role];
                }, []);
                this.permissionsService.addPermission(roles);
            }
        });

        this.filters = this.service.getCalendarItems().pipe(map(c => c.calendar_items));
    }

    selectFilter(index = 0) {
        this.calendarItems$ = this.service.getCalendarItems().pipe(map(c => c.calendar_items[index].list));
    }

    trackByFn = (index, item) => item.id || index;
}
